import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";

const GreenSwitch = withStyles({
  root: {
    width: 36,
    height: 20,
    padding: 0,
    display: "flex",
    overflow: "visible",
  },
  switchBase: {
    padding: 2,
    color: "#fff !important",
    "&:hover": { backgroundColor: "transparent !important" },
    "&$checked": {
      transform: "translateX(16px)",
      color: "#fff !important",
      "&:hover": { backgroundColor: "transparent !important" },
      "& + $track": {
        opacity: "1 !important",
        backgroundColor: "#4caf50 !important",
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    backgroundColor: "#fff !important",
  },
  track: {
    borderRadius: 10,
    opacity: "1 !important",
    backgroundColor: "#bdbdbd !important",
  },
  checked: {},
})(Switch);

const useStyles = makeStyles((theme) => ({
  toggleCard: {
    borderRadius: 10,
    border: theme.mode === "dark"
      ? "1px solid rgba(255,255,255,0.1)"
      : "1px solid #e0e0e0",
    marginBottom: 8,
    transition: "all 0.2s ease",
    overflow: "hidden",
    "&:hover": {
      borderColor: theme.mode === "dark"
        ? "rgba(255,255,255,0.2)"
        : "#bdbdbd",
    },
  },
  toggleHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
    cursor: "default",
  },
  toggleLabel: {
    fontSize: "0.9rem",
    fontWeight: 500,
    color: theme.mode === "dark" ? "#e0e0e0" : "#424242",
  },
  toggleDesc: {
    fontSize: "0.75rem",
    color: theme.mode === "dark" ? "#888" : "#999",
    marginTop: 2,
  },
  toggleContent: {
    padding: "0 16px 12px",
  },
}));

const ChatiaToggleItem = ({ label, description, checked, onChange, disabled, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.toggleCard}>
      <div className={classes.toggleHeader}>
        <div>
          <span className={classes.toggleLabel}>{label}</span>
          {description && <div className={classes.toggleDesc}>{description}</div>}
        </div>
        <GreenSwitch
          checked={!!checked}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
      {checked && children && (
        <div className={classes.toggleContent}>
          {children}
        </div>
      )}
    </div>
  );
};

export default ChatiaToggleItem;
export { GreenSwitch };
